module.exports = __webpack_public_path__ + "img/qmr1.500dc1b1.jpg";